import React from "react";
import { Rate } from "antd";

function UIRating({
  value = 0,
  desc = "",
  size = 16,
  color,
  disabled = false,
  allowHalf = false,
  style = {},
  className = {},
  onChange = () => {},
}) {
  return (
    <div>
      <Rate
        className={className}
        allowHalf={allowHalf}
        tooltips={desc}
        onChange={onChange}
        value={value}
        style={{ fontSize: size, color: color, ...style }}
        disabled={disabled}
      />
    </div>
  );
}

export default UIRating;
